const x = {
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1536
}, i = {
  sm: "(max-width: 767px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 992px)",
  xl: "(min-width: 1200px)",
  "2xl": "(min-width: 1536px)"
};
export {
  x as DEFAULT_BREAKPOINTS,
  i as RESPONSIVE_MAP
};
//# sourceMappingURL=breakpoints.js.map
